import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToasterService } from 'src/app/services/toaster.service';
import { ProjectsearchService } from 'src/app/services/projectsearch.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { messages } from 'src/app/popUpMessages/messages';

interface ProjectOption {
  id: number;
  name: string;
}

@Component({
  selector: 'app-config-fwd-popup',
  templateUrl: './config-fwd-popup.component.html',
  styleUrls: ['./config-fwd-popup.component.css']
})
export class DuplicateConfigurationPopupComponent implements OnInit {
  availableProjects: any = [];
  form: FormGroup;
  loading = false;

  displayConfiguration = '';

  searchControl = new FormControl(''); // Add this property
  filteredProjects: any = []; // Add this property


  constructor(
    private dialogRef: MatDialogRef<DuplicateConfigurationPopupComponent>,
    private toast: ToasterService,
    private configurationService: ConfigurationService,
    private projectService: ProjectService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      projectId: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    const idPart = this.data?.configurationId;
    const namePart = this.data?.rowData?.ConfigurationName || this.data?.rowData?.Name || '';
    this.displayConfiguration = `ID ${idPart}${namePart ? ' - ' + namePart : ''}`;
    // this.form = this.fb.group({
    //   projectId: [null, Validators.required]
    // });
    this.loadProjects(this.data?.projectId);
    this.searchControl.valueChanges.subscribe(searchTerm => {
      this.filterProjects(searchTerm || '');
    });
  }


  getSelectedProjectLabel(id: number | null | undefined): string | null {
    if (id == null) return null;
    const p = this.availableProjects?.find(x => x.ProjectId === id);
    return p ? `ID ${p.ProjectId} - ${p.ProjectTitle}` : null;
  }

  filterProjects(searchTerm: string): void {
    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredProjects = this.availableProjects;
    } else {
      console.log(searchTerm);
      const lowerSearch = searchTerm.toLowerCase();
      this.filteredProjects = this.availableProjects.filter(p =>
        p.ProjectId.toString().includes(lowerSearch) ||
        p.ProjectTitle.toLowerCase().includes(lowerSearch)
      );
    }
  }


  compareProjects(c1: any, c2: any): boolean {
    return c1 !== null && c2 !== null ? c1 === c2 : c1 === c2;
  }

  onProjectChange(value: any): void {
    this.form.patchValue({ projectId: value });
  }

  private loadProjects(currentProjectId?: number) {
    this.projectService.getTCAllProjectsByUserId(this.data?.userId, this.data?.rowData?.businessAreaId, this.data?.rowData?.businessLineId).subscribe((data: any) => {
      let errorMsgeFromBack = data.Data.Message;
      if (data.StatusCode == 200) {
        this.availableProjects = data.Data;
        this.availableProjects = this.availableProjects.filter(p => p.ProjectId !== currentProjectId);
        this.filteredProjects = this.availableProjects; // Add this line
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer)

      }
    },
      (error) => {
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
      });
    // TODO: Replace with your real service
    // this.projectSearchService.getAll().subscribe({
    //   next: (projects: ProjectOption[]) =>
    //     this.availableProjects = (projects || []).filter(p => p.id !== currentProjectId),
    //   error: () => this.toast.error('Failed to load projects')
    // });

    // Stub (remove when wiring):
    // const stub: ProjectOption[] = [
    //   { id: 15, name: 'mAtch' },
    //   { id: 56, name: 'Groot Floor w Megalix' },
    //   { id: 89, name: 'Nimbus' },
    //   { id: 24, name: 'Orion' }
    // ];
    // this.availableProjects = stub.filter(p => p.id !== currentProjectId);
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  onForwardClick(event: any): void {
    const confirmDialog = this.dialog.open(DialogComponent, {
      data: {
        message: messages.forwardConfigurationMessage,
        okBtn: 'Yes',
        cancelBtn: 'No'
      }
    });

    confirmDialog.afterClosed().subscribe((result: boolean) => {
      if (result === true) {
        this.onSubmit(event);
      }
    });
  }

  onSubmit(event: Event) {
    event.preventDefault();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const targetProjectId = this.form.value.projectId as number;
    const configurationId = this.data.configurationId;
    const userId = this.data.userId;

    this.loading = true;

    // TODO: Wire API
    this.configurationService.ForwardConfiguration(configurationId, targetProjectId, userId).toPromise()
      .then((res) => {
        let submitResponse = res;
        let successCode = submitResponse.StatusCode;
        let errorCode = submitResponse.Data.ErrorCode;
        let errorMsgeFromBack = submitResponse.Data.Message;
        if (successCode == 200 && errorCode == 0) {
          this.toast.notify(serverMessage.dataSaveMessage, "success");
          this.loading = false;
          // this.toast.success('Configuration forwarded successfully');
          this.dialogRef.close(true);
        }
        else {
          //Show errorCode and errorMessage in the UI
          let errorContainer = [
            { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer)
          this.loading = false;
          // this.submitted = false;
          return false;
        }
      }, (error) => {
        let errorContainer = [
          { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer)
        this.loading = false;
      });
  }
}
